<div id="esign-doc-review-modal" tabindex="-1" role="dialog">
  <div role="document">
    <div
      class="modal-body bl-padding-top--24 bl-padding-top-md--32 bl-max-width--1136 bl-margin-x--auto bl-margin-x--auto bl-max-width--desktop bl-padding-bottom--32"
    >
      <div class="bl-font-color--black bl-font-weight--800 bl-font-size--22">{{ stipulation?.name }}</div>
      <div class="bl-display-md--flex bl-margin-top--24">
        <div class="bl-col-lg-12 bl-col-md-12 bl-col-sm-12 bl-padding-x--0 bl-border bl-bg-color--white">
          <div class="bl-border bl-padding--0 bl-margin--32 bl-bg-color--white">
            <div id="portal-content" class="bl-border border-radius document-review-container">
              @if (loading) {
                <div>
                  <div class="loader-bg">
                    <!--REFACTOR: This loader needs to be redone, it should not be using the global app loader -->
                    <div class="circle-loader"></div>
                  </div>
                </div>
              }
              @if (docSource) {
                <ea-pdf-embed [pdfSrc]="docSource" (pdfLoadComplete)="pdfComplete($event)"></ea-pdf-embed>
              }
            </div>
          </div>
          @if (docSource) {
            <div class="bl-padding-x--24 bl-clearfix bl-margin-y--32">
              <button
                type="button"
                [innerHTML]="'documentReview/download' | dictionary"
                class="bl-button bl-float-md--right bl-text-align--right"
                (click)="download()"
              ></button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
